import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import API from "../base/API";
import Auth from "../auth/Auth";
import TranslationForm from "./TranslationForm";

export default class TranslationNew extends Auth {


	constructor(props) {
		super(props);

		this.api = new API({
			save_translation: "/translation/save/new"
		});

		this.state = {
			translation: {
				language: "sk",
				original: "",
				translated: ""
			},
		}
	}

	saveData() {
		this.api.request({
			route: "save_translation",
			data: this.state.translation,
			created: (response) => {
				browserHistory.push("/translations");
			}
		});
	}

	onChange(evt) {
		let translation = this.state.translation;

		translation[evt.target.name] = evt.target.value;

		this.setState({ translation });
	}

	render() {
		return (
			<Page>
				<PageHeader title={this.state.translation.original} />
				<PageBody>
					<TranslationForm data={this.state.translation} onSave={this.saveData.bind(this)} onChange={this.onChange.bind(this)} />
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/translation/TranslationNew.js